import { Flex, Box, Text } from "rebass/styled-components";
import styled from "styled-components";

interface AvatarItem {
  id: string | number;
  name: string;
  image?: string;
}

const Avatar = styled.img<{ index: number }>`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.colors.midnight};
  margin-left: ${(props) => (props.index > 0 ? "-15px" : "0")};
  z-index: ${(props) => 10 - props.index};
  position: relative;
`;

const StackedAvatars = ({
  users,
  visible,
  onClick,
}: {
  users: AvatarItem[];
  visible: boolean;
  onClick: () => void;
}) => {
  const avatars = users.filter((user) => user.image);

  return (
    <Flex
      onClick={onClick}
      style={{
        opacity: visible ? 0.5 : 0,
        transition: "opacity 0.3s ease-in-out",
        flexShrink: 0,
        minWidth:
          avatars.length > 0 ? `${30 + (avatars.length - 1) * 12}px` : "0px",
      }}
    >
      {avatars.map((user, index) => (
        <Avatar key={user.id} src={user.image} alt={user.name} index={index} />
      ))}
    </Flex>
  );
};

export default StackedAvatars;
